@use 'variables' as *;
@use 'mixins' as *;
@use 'sass:map';

// -----

$-sizes: (
  'xl': 3rem,
  'l': 2.5rem,
  'm': 2rem,
  's': 1.5rem,
  'xs': 1rem
);
$-paddings: (
  'xl': 0 1rem,
  'l': 0 1rem,
  'm': 0 0.75rem,
  's': 0 0.5rem,
  'xs': 0 0.25rem
);

// -----

:host([hidden]) {
  display: none;
}

:host {
  display: inline-flex;
  max-width: 100%;
  vertical-align: baseline;
  align-items: center;
  justify-content: center;
  border-radius: cat-border-radius('m');
  text-decoration: none;
  line-height: 1.5;
  flex-shrink: 0;

  slot {
    display: inline-block;
    @include cat-ellipsis;
  }
}

// ----- round

:host([round]) {
  border-radius: 10rem;
}

// ----- theme

$-outline: inset 0 0 0 1px cat-token-wrap(var(--text), $alpha: 0.2);

:host([variant='filled']) {
  background-color: cat-token-wrap(var(--bg));
  color: cat-token-wrap(var(--fill));
  font-weight: 600;
  @include cat-font-smooth;
}

:host([variant='outlined']) {
  background-color: cat-token('color.ui.background.surface');
  color: cat-token-wrap(var(--text));
  box-shadow: $-outline;
}

@mixin theme($theme) {
  :host([color='#{$theme}']) {
    --bg: #{cat-token('color.theme.#{$theme}.bg', $wrap: false)};
    --fill: #{cat-token('color.theme.#{$theme}.fill', $wrap: false)};
    --text: #{cat-token('color.theme.#{$theme}.text', $wrap: false)};
  }
}

@include theme('primary');
@include theme('secondary');
@include theme('info');
@include theme('success');
@include theme('warning');
@include theme('danger');

// ----- size

@mixin size($size, $fontSize) {
  $-total-height: map.get($-sizes, $size);
  :host([size='#{$size}']) {
    height: map.get($-sizes, $size);
    min-width: map.get($-sizes, $size);
    font-size: cat-body-font-size($fontSize);
    padding: map.get($-paddings, $size);
    gap: 0.25rem;
  }
  :host([data-icon-badge='#{$size}']) {
    width: $-total-height;
    height: $-total-height;
    padding: 0;
  }
}

@include size('xs', 'xs');
@include size('s', 'xs');
@include size('m', 's');
@include size('l', 'm');
@include size('xl', 'l');

// ----- pulse

$-pulse-0: 0 0 0 0 cat-token-wrap(var(--bg));
$-pulse-70: transparent 0 0 0 0.5rem;
$-pulse-100: transparent 0 0 0 0;

:host([pulse][variant='filled']) {
  animation: 1.5s ease 0s infinite normal none running pulse;
}

:host([pulse][variant='outlined']) {
  animation: 1.5s ease 0s infinite normal none running pulse-outlined;
}

@keyframes pulse {
  0% {
    box-shadow: $-pulse-0;
  }

  70% {
    box-shadow: $-pulse-70;
  }

  100% {
    box-shadow: $-pulse-100;
  }
}

@keyframes pulse-outlined {
  0% {
    box-shadow: $-pulse-0, $-outline;
  }

  70% {
    box-shadow: $-pulse-70, $-outline;
  }

  100% {
    box-shadow: $-pulse-100, $-outline;
  }
}
